import api from "../index";

export const GetAllFaqApi = (params) => api.get(`FAQsMaster/GetActive-FAQs?${params}`);